// ─── Écriture / lecture d'un fichier JSON — web + natif ────────────
// Web : téléchargement / <input type=file>. Natif : cache + expo-sharing /
// expo-document-picker. Même pattern que feature-inventory/services/io.js —
// pas partagé via @mop/core (chaque module MoPCal avait déjà sa propre copie
// de cette logique : catalogueIngredients, inventaireIO, PlanningRepasScreen).
import { Platform } from 'react-native';

export async function exporterFichier({ nomFichier, contenu }) {
  if (Platform.OS === 'web') {
    const blob = new Blob([contenu], { type: 'application/json;charset=utf-8' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = nomFichier;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return { ok: true, methode: 'download' };
  }
  const L = require('expo-file-system/legacy');
  const Sharing = require('expo-sharing');
  const uri = (L.cacheDirectory || '') + nomFichier;
  await L.writeAsStringAsync(uri, contenu, { encoding: (L.EncodingType && L.EncodingType.UTF8) || 'utf8' });
  if (await Sharing.isAvailableAsync()) {
    await Sharing.shareAsync(uri, { mimeType: 'application/json', dialogTitle: nomFichier, UTI: 'public.json' });
  }
  return { ok: true, methode: 'share' };
}

function choisirFichierWeb(accept) {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = () => resolve(input.files && input.files[0] ? input.files[0] : null);
    input.click();
  });
}

// Renvoie le TEXTE du fichier choisi, ou null si annulé.
export async function choisirEtLireFichier(accept = 'application/json,.json') {
  if (Platform.OS === 'web') {
    const f = await choisirFichierWeb(accept);
    return f ? await f.text() : null;
  }
  const DocumentPicker = require('expo-document-picker');
  const res = await DocumentPicker.getDocumentAsync({ copyToCacheDirectory: true, type: '*/*' });
  const a = res.assets && res.assets[0];
  if (res.canceled || !a || !a.uri) return null;
  const FS = require('expo-file-system');
  if (FS && FS.File) return await new FS.File(a.uri).text();
  const L = require('expo-file-system/legacy');
  return await L.readAsStringAsync(a.uri);
}
